<!--  -->
<template>
  <div>
    <div>
      <vxe-modal
          v-model="editReceivingModal"
          width="1300"
          height="700"
          position="center"
          showFooter
          title="结算详情编辑"
          destroy-on-close
      >
        <div class="infoPaddingCss add-box">
          <div>
            <div class="flexButton">
              <span class="fontWeight">订单信息</span>
              <div
                  style="color: #a7adad"
              >创建人: {{ deailCreateUser }} | 创建日期: {{ deailCreateTime | timePartRule }}
              </div>
            </div>
          </div>
          <vxe-table
              auto-resize
              border="inner"
              :data="orderTableData"
              align="center"
          >
            <vxe-table-column field="paymentsNum" title="结算编号" show-overflow>
            </vxe-table-column>
            <vxe-table-column
                field="ordersNum"
                title="订单编号"
                show-overflow
            >
            </vxe-table-column>
            <vxe-table-column
                field="buyerName"
                title="托运人名称"
            ></vxe-table-column>
            <vxe-table-column title="平台企业" field="compName">
            </vxe-table-column>
            <vxe-table-column
                field="sellerName"
                title="承运人名称"
            ></vxe-table-column>
          </vxe-table>
        </div>
        <div style="margin-top: 10px">
          <div class="flexButton">
            <span class="fontWeight">物流信息</span>
          </div>
          <vxe-table
              auto-resize
              border="inner"
              :data="logisticsShowData"
              stripe
              highlight-hover-row
              align="center"
          >
            <vxe-table-column field="goodsName" title="货名" show-overflow></vxe-table-column>
            <vxe-table-column field="goodsUnit" title="单位"></vxe-table-column>
            <vxe-table-column field="realCount" title="实际数量"></vxe-table-column>
            <vxe-table-column field="carShipNum" title="车船号" show-overflow>
              <template slot-scope="{ row }">
              <span
                  v-if="row.trackUrl || row.logisticsType === 2"
                  @click="getMap(row)"
                  style="color: #2D8CF0;cursor:pointer"
              >{{ row.carShipNum }}</span>
                <span v-if="!row.trackUrl && row.logisticsType !== 2 ">{{ row.carShipNum }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="beginPlace" title="起运地" show-overflow></vxe-table-column>
            <vxe-table-column field="beginTime" title="起运时间" width="100">
              <template slot-scope="{ row }">
                <span style="color: #a7adad">{{ row.beginTime | timePartRule }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="endPlace" title="到达地" show-overflow></vxe-table-column>
            <vxe-table-column field="endTime" title="到达时间" width="100">
              <template slot-scope="{ row }">
                <span style="color: #a7adad">{{ row.endTime | timePartRule }}</span>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
        <div style="margin-top: 10px" class="infoPaddingCss">
          <div class="flexButton">
            <span class="fontWeight">结算信息</span>
          </div>
          <vxe-table
              auto-resize
              border="inner"
              ref="xTable"
              align="center"
              :data="receivingTableData"
              :edit-rules="formRules"
              :edit-config="{ trigger: 'click', mode: 'cell' }"
          >
            <vxe-table-column
                title="结算类型"
                field="paymentType"
            >
              <template v-slot:header>
                <span style="color: red">*</span>结算类型
              </template>
              <template v-slot="{ row }">
                <vxe-select
                    v-model="row.paymentType"
                    placeholder="请选择"
                    @blur="clearTableV"
                    transfer
                    :disabled="true"
                >
                  <vxe-option :value=1 label="托运人结算"></vxe-option>
                  <vxe-option :value=2 label="承运人结算"></vxe-option>
                </vxe-select>
              </template>
            </vxe-table-column>
            <template v-slot:header>
              <span style="color: red">*</span>结算时间
            </template>
            <vxe-table-column field="addTime" title="结算时间">
              <template v-slot="{ row }">
                <vxe-input
                    v-model="row.paymentTime"
                    placeholder="选择日期"
                    type="date"
                    transfer
                    :disabled="row.note === '运费结算确认'"
                    @blur="clearTableV"
                ></vxe-input>
              </template>
            </vxe-table-column>

            <vxe-table-column field="amount" title="结算金额">
              <template v-slot:header>
                <span style="color: red">*</span>结算金额
              </template>
              <template v-slot="{ row }">
                <vxe-input
                    v-model="row.amount"
                    placeholder="必填"
                    @blur="clearTableV"
                ></vxe-input>
              </template>
            </vxe-table-column>
            <vxe-table-column field="note" title="摘要">
              <template v-slot:header>
                <span style="color: red">*</span>摘要
              </template>
              <template v-slot="{ row }">
                <vxe-select v-model="row.note" :options="noteList" transfer
                            :disabled="paymentsId && buyerAmountId && sellerAmountId && (paymentsId === buyerAmountId || paymentsId === sellerAmountId)"></vxe-select>
              </template>
            </vxe-table-column>
            <vxe-table-column field="remark" title="备注">
              <template v-slot="{ row }">
                <vxe-input v-model="row.remark" placeholder="选填" @blur="clearTableV"></vxe-input>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
        <div class="add-box">
          <vxe-table
              border
              show-overflow
              :auto-resize="true"
              class="table-upload-style"
              max-height="200"
              style="margin-bottom: 35px"
              :data="uploadData"
              :edit-config="{ trigger: 'click', mode: 'cell' }"
          >
            <vxe-table-column field="url" title="上传附件">
              <template v-slot="{ row }">
                <upload-list
                    :isEdit="true"
                    :row="row"
                    :initFileList="uploadList"
                    :view="'arrange'"
                ></upload-list>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>

        <div slot="footer">
          <vxe-button
              status="primary"
              style="width: 140px; border-radius: 0px"
              @click="cancelSubmit"
          >取消
          </vxe-button
          >
          <vxe-button
              type="submit"
              status="primary"
              @click="submitEdit()"
              style="width: 140px; border-radius: 0px"
          >保存
          </vxe-button
          >
        </div>
      </vxe-modal>
    </div>
    <div v-show="trackFlag" class="trackBox">
      <div style="display: flex; justify-content: space-between">
        <div
            style="
            margin-left: 10px;
            font-size: 14px;
            font-weight: bold;
            line-height: 30px;
          "
        >
          {{ isCar ? "车辆轨迹" : "船舶轨迹" }}
        </div>
        <div
            @click="trackFlag = false"
            style="
            margin-right: 5px;
            cursor: pointer;
            line-height: 30px;
            height: 30px;
            background: #409eff;
            color: #fff;
            border-radius: 5px;
            width: 60px;
            font-size: 12px;
            font-size: 12px;
            text-align: center;
          "
        >
          关闭
        </div>
      </div>
      <iframe
          ref="mapFrame"
          style="width: 100%; height: 85vh; overflow: hidden"
          frameborder="0"
          name="showHere"
          scrolling="auto"
          :src="url"
      ></iframe>
      <!--      <iframe-view v-if="!isCar" :obj="shipObj"></iframe-view>-->
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import auth from "@/utils/auth";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import ChooseLogistics from "@/components/modal/ChooseLogistics";
import ChooseOrderTwo from "@/components/modal/ChooseOrderTwo";
import {showLoading, hideLoading} from "@/utils/util";
import PlatformCorp from "@/components/common/PlatformCorp";

import UploadList from "@/components/common/UploadList";
import moment from "moment";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  components: {
    UploadList,
  },
  mixins: [getAuthOrization],
  data() {
    return {
      orderVisible: false,
      editReceivingModal: false,
      isChooseOrder: false,
      logisticsShowData: [],
      logisticsVisible: false,
      orderTypeTwo: 1,
      orderType: 1,
      orderNum: null,
      currentPage2: 1,
      pageSize2: 5,
      isCar: true,
      url: null,

      totalResult2: 300,
      trackFlag: false,
      deailReceiveNum: null,
      receivingComp: null,
      platformCompanyId: null,
      deailCreateUser: null,
      deailCreateTime: null,
      orderTableData: [],
      showPicIndex: 0,
      receivingTableData: [],
      logisticsTableData: [],
      logisticDetailVisible: false,
      uploadData: [
        {
          fileUuidList: [],
        },
      ],
      formRules: {
        amount: [{required: true, message: "请结算金额"}],
        paymentType: [{required: true, message: "请选择结算类型"}],
        paymentTime: [{required: true, message: "请选择时间"}],
        note: [{required: true, message: "请选择摘要"}],
      },
      uploadList: [],
      unitTypeOptions: [],
      noteList: [],
      paymentsId: null,
      buyerAmountId: null,
      sellerAmountId: null
    };
  },
  filters: {
    timePartRule: function (t) {
      if (t) {
        var timeB = new Date(t);
        var y = 1900 + timeB.getYear();
        var m = "0" + (timeB.getMonth() + 1);
        var d = "0" + timeB.getDate();

        return (
            y +
            "-" +
            m.substring(m.length - 2, m.length) +
            "-" +
            d.substring(d.length - 2, d.length)
        );
      } else {
        return "";
      }
    },
  },
  methods: {
    getDicDate() {
      this.unitTypeOptions = [];

      $api.other.getUnitTypeModel
          .GET({
            params: {
              page: 1,
              rows: 100,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              var obj = {
                label: item.dictText,
                value: item.dictText,
              };
              this.unitTypeOptions.push(obj);
            });
          });
    },
    editReceiving(row) {
      if (!this.isHavePermission('twoSettlement:detail')) {
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return;
      }
      this.orderTypeTwo = 1;
      this.getReceivingDetail(row);
      this.editReceivingModal = true;
      this.getDicDate();
      this.getDictByCodeP(58000);
    },
    async getDictByCodeP(code) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code
      });
      if (res.status === 1) {
        let data = res.data;
        let arr = [];
        data.map(i => {
          arr.push({
            label: i.dictText,
            value: i.dictText,
          })
        })
        this.noteList = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    cancelSubmit() {
      this.editReceivingModal = false;
    },
    handleCurrentChange2(val) {
      this.logisticsShowData = this.logisticsTableData.slice(
          (val.currentPage - 1) * val.pageSize,
          val.currentPage * val.pageSize
      );
      console.log(this.logisticsShowData);
    },

    async getReceivingDetail(row) {
      var self = this;
      self.logisticsShowData = [];
      self.receivingTableData = [];
      self.orderTableData = [];
      self.editUuidList = [];
      self.uploadList = [];

      var objReceive = {};
      var objOrder = {};
      var objLogistic = {};
      var data = {
        id: row.id,
      };
      showLoading()
      let response = await $api.twoSettlement.request(
          "detail",
          data
      );
      hideLoading();
      if (response.status == 1) {
        showLoading()
        let res = response.data;
        self.deailReceiveNum = res.paymentsDetail.paymentsNum;
        self.deailCreateUser = res.paymentsDetail.updateUser;
        self.deailCreateTime = res.paymentsDetail.updateTime;
        //结算信息
        // objReceive.addTime = res.addTime;
        objReceive.paymentTime = this.$utils.toDateString(
            res.paymentsDetail.addTime,
            "yyyy-MM-dd"
        );

        objReceive.id = res.paymentsDetail.id;
        objReceive.amount = res.paymentsDetail.totalAmount;
        objReceive.paymentType = res.paymentsDetail.paymentType;
        objReceive.note = res.paymentsDetail.note;
        objReceive.remark = res.paymentsDetail.remark;
        self.receivingTableData.push(objReceive);
        //订单信息
        self.paymentsId = res.paymentsDetail.id;
        self.buyerAmountId = res.ordTwoOrders.buyerAmountId;
        self.sellerAmountId = res.ordTwoOrders.sellerAmountId;

        objOrder.ordersNum = res.ordTwoOrders.ordersNum;
        objOrder.paymentsNum = res.paymentsDetail.paymentsNum;
        objOrder.buyerName = res.ordTwoOrders.buyerName;
        objOrder.chainNum = res.ordTwoOrders.chainNum;
        objOrder.sellerName = res.ordTwoOrders.sellerName;
        objOrder.chainId = res.ordTwoOrders.chainId;
        objOrder.compName = res.ordTwoOrders.compName;
        objOrder.createUser = res.ordTwoOrders.createUser;
        objOrder.createTime = res.ordTwoOrders.createTime;
        objOrder.ordersBuyerId = res.ordTwoOrders.ordersBuyerId;
        objOrder.ordersSellerId = res.ordTwoOrders.ordersSellerId;
        objOrder.ordersSellerLv2Id = res.ordTwoOrders.ordersSellerLv2Id;
        self.orderTableData.push(objOrder);
        //物流信息
        objLogistic.goodsName = res.ordTwoOrders.goodsName;
        objLogistic.goodsUnit = res.ordTwoOrders.goodsUnit;
        objLogistic.realCount = res.ordTwoOrders.realCount;
        objLogistic.carShipNum = res.ordTwoOrders.carShipNum;
        objLogistic.logisticsType = res.ordTwoOrders.logisticsType;
        objLogistic.trackUrl = res.ordTwoOrders.trackUrl;
        objLogistic.beginPlace = res.ordTwoOrders.beginPlace;
        objLogistic.beginTime = res.ordTwoOrders.beginTime;
        objLogistic.endPlace = res.ordTwoOrders.endPlace;
        objLogistic.endTime = res.ordTwoOrders.endTime;
        self.logisticsShowData.push(objLogistic);
        //图片信息
        if (res.fileList != null) {
          res.fileList.map((i) => {
            self.editUuidList.push(i.uuid);
            self.uploadList.push(i);
          });
        }
      }

    },

    clearTableV() {
      this.$refs.xTable.clearValidate();
    },
    getMap(row) {
      if (row.logisticsType === 1) {
        this.isCar = true;
        this.seeCarMap(row);
      } else {
        this.isCar = false;
        this.seeShipMap(row);
      }
    },
    seeCarMap(row) {
      let that = this;
      this.trackFlag = true;
      this.url = '/carShip/fwCarFrame';
      this.$nextTick(function () {
        setTimeout(function () {
          let mapFrame = that.$refs.mapFrame;
          let iframeWin = mapFrame.contentWindow;
          iframeWin.postMessage(JSON.stringify({carInfo: row, logistics: true, top: true}), '*');
        }, 5000);
      });
    },
    changeLogistic() {
      if (this.orderTableData[0].ordersBuyerNum == null) {
        this.$XModal.alert({
          message: "请先选择订单",
          status: "error",
        });
        return;
      }
      this.logisticsVisible = true;
      this.$refs.chooseLogistics.init();
    },
    seeShipMap(row) {
      let mmsi = row.mmsi ? row.mmsi : row.carShipNum;
      if (mmsi == null || mmsi === "") {
        //暂无数据
        this.$Message.error("暂无数据");
        return;
      }
      let beginTime = moment(row.beginTime).format("YYYY-MM-DD");
      let deliveryDates = moment(row.endTime).format("YYYY-MM-DD");
      let obj = {
        startTime: beginTime + " 00:00:00",
        endTime: deliveryDates + " 00:00:00",
        mmsi: mmsi,
      };
      this.trackFlag = true;
      let that = this;
      if (this.url === "/carShip/fwShipFrame") {
        let mapFrame = that.$refs.mapFrame;
        let iframeWin = mapFrame.contentWindow;
        iframeWin.postMessage(JSON.stringify(obj), "*");
      } else {
        this.url = "/carShip/fwShipFrame";
        this.$nextTick(function () {
          setTimeout(function () {
            let mapFrame = that.$refs.mapFrame;
            let iframeWin = mapFrame.contentWindow;
            iframeWin.postMessage(JSON.stringify(obj), "*");
          }, 5000);
        });
      }
    },
    // 船舶日期往前推N天
    clickFile(url) {
      window.open(url);
    },

    async validEvent() {
      let errMap = await this.$refs.xTable.validate().catch((errMap) => errMap);
      return errMap ? false : true;
    },
    async submitEdit() {
      let sts = await this.validEvent();
      if (!sts) {
        this.$XModal.message({status: "error", message: "校验不通过！"});
        return;
      }
      var tempCopy = {
        logisticsIdList: [],
      };
      if (this.receivingTableData[0].addTime) {
        tempCopy.addTime = this.$utils.timestamp(
            this.receivingTableData[0].addTime
        );
      }
      tempCopy.id = this.receivingTableData[0].id;
      tempCopy.amount = this.receivingTableData[0].amount;
      tempCopy.paymentType = this.receivingTableData[0].paymentType;
      tempCopy.note = this.receivingTableData[0].note;
      tempCopy.paymentTime = this.receivingTableData[0].paymentTime ? this.$utils.timestamp(this.receivingTableData[0].paymentTime) : null;
      tempCopy.fileUuidList = this.uploadData[0].fileUuidList;
      tempCopy.remark = this.receivingTableData[0].remark;
      showLoading();
      let res = await $api.twoSettlement.request(
          "update",
          tempCopy
      );
      hideLoading();
      if (res.status == 1) {
        this.$emit("updateList", true);
        this.$Message["success"]({
          background: true,
          content: "更新成功",
        });
        this.editReceivingModal = false;
      } else {
        this.$emit("closeEdit", false);
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
  },
};
</script>
<style>
.trackBox {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 100;
  background: #fff;
}

/* .flexButton {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
} */
.pdf-box1 {
  display: inline-block;
  position: relative;
  line-height: 60px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  width: 60px;
  height: 60px;
  overflow: hidden;
}

.infoPaddingCss .vxe-pager .vxe-pager--sizes {
  width: 7em;
  text-align: center;
  cursor: pointer;
  display: none;
}
</style>
